import Vue from 'vue'
import App from './App.vue'
import router from '@/router.js'
import store from '@/store/store.js'
import socketInstance from '@/services/socket.js'
import '@/filters.js'
import '@/services/directives.js'
import modal from '@/plugins/modal.js'
import bus from '@/services/bus.js'
import i18n from '@/services/i18n'
import tippy from 'tippy.js'

import DefaultLayout     from '@/layouts/Default.vue'
import AuthLayout        from '@/layouts/Auth.vue'
import ChildLayout       from '@/layouts/Child.vue'
import EmptyLayout       from '@/layouts/Empty.vue'
import OnlyHeaderLayout  from '@/layouts/OnlyHeader.vue'

import VueInfiniteScroll from 'vue-infinite-scroll'
import VueScrollTo       from 'vue-scrollto'
import PortalVue         from 'portal-vue'
import VeeValidate       from 'vee-validate'
import VueNotification   from 'vue-notification'
import VueMq             from 'vue-mq'
import * as Sentry       from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

// by default max-width: 350px
tippy.setDefaults({ maxWidth: 'none' })

import {
  loadBaseComponents,
  loadIcons,
  bootstrap
} from '@/services/bootstrap/bootstrap.js'

if (process.env.VUE_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [
      new Integrations.Vue({ Vue, attachProps: true })
    ],
    logError: true
  })
}

Vue.config.productionTip = false
Vue.prototype.$bus = bus

Vue.component('default-layout', DefaultLayout)
Vue.component('auth-layout', AuthLayout)
Vue.component('child-layout', ChildLayout)
Vue.component('empty-layout', EmptyLayout)
Vue.component('only-header-layout', OnlyHeaderLayout)

Vue.use(modal)
Vue.use(VueInfiniteScroll)
Vue.use(VueScrollTo)
Vue.use(PortalVue)
Vue.use(VeeValidate)
Vue.use(VueNotification, { componentName: 'vue-notification' })
Vue.use(VueMq, {
  breakpoints: {
    mobile: 500,
    small: 1281,
    medium: 1440,
    big: Infinity,
  },
  defaultBreakpoint: 'big'
})

loadBaseComponents()
loadIcons()

// todo: what if the socket connection has failed?

// On the initial load we need to establish socket connection.
// Otherwise there is no point in showing any screen
// e.g. login screen as login request won't work.
socketInstance.on('connect', status => {
  let authenticated = status.isAuthenticated
  store.dispatch('auth/setIsAuthenticated', authenticated)

  // If the user is authenticated then we need to load some
  // initial stuff to the vuex store, such as children
  // data (avatars, statuses etc), plus set timers.
  if (authenticated) {
    bootstrap().then(() => {
      initApp()
    })
  } else {
    // Otherwise the login screen will be shown which does not require any data
    initApp()
  }
})

function initApp() {
  new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app')
}
